import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	Toolbar as RhombusToolbar,
	ToggleFilter
} from "rhombus-react";
import { selectVersionType, setVariableSearchTerm } from "reducers/VersionDetails";
import { SEARCH_DEBOUNCE } from "utils/constants";

export const VERSION_TOGGLE_VIEWS = {
	Text:{
		name:"Text",
		title:"Text",
		icon: "fas fa-font-case",
		value:"Text",
	},
	Image:{
		name:"Images",
		title:"Images",
		icon: "assetImage",
		value:"Image",
	},
	Richload:{
		name:"Richloads",
		title:"Richloads",
		icon: "assetRichload",
		value:"Richload",
	},
	Video:{
		name:"Videos",
		title:"Videos",
		icon: "assetVideo",
		value:"Video",
	},
};

export default function Toolbar({ isLoading }){
	const dispatch = useDispatch();
	let {
			types,
			selectedTypes,
			searchTerm,
		} = useSelector(state => state.versionDetails)
		, toggleVals = types?.map(type=>VERSION_TOGGLE_VIEWS[type])
		, updateVariableTypeFilter = (varType)=>{
			dispatch(selectVersionType(varType));
		}
		;

	const searchProps = {
		isDisabled:  isLoading,
	};

	function onSearch(newSearchTerm){
		dispatch(setVariableSearchTerm(newSearchTerm));
	}

	return (
		<RhombusToolbar
			className="edit-version-toolbar"
			search
			searchDebounce = {SEARCH_DEBOUNCE}
			onSearch = {onSearch}
			searchValue = {searchTerm}
			searchProps = {searchProps}
		>
			<div className="edit-version-toggle-container">
				<ToggleFilter
					key="toggle-filter"
					disabled={false}
					values={toggleVals}
					selectedView = {selectedTypes}
					onViewChange = {updateVariableTypeFilter}
				/>
			</div>
		</RhombusToolbar>
	);
}
